//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rectangle from './Rectangle.vue'

export default {
  components: { Rectangle },
  props: {
    routeSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    rmsOkoRegisteredBlackAndYellow: function () {
      return this.getChildrenBlockByType('rmsOkoRegisteredBlackAndYellow')
    },
    rmsOkoRegisteredNotBlackAndYellow: function () {
      return this.getChildrenBlockByType('rmsOkoRegisteredNotBlackAndYellow')
    }
  },
  methods: {
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.routeSource && this.routeSource.compound && this.routeSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
